import { Outlet } from 'react-router-dom'

const BannerPage = () => <Outlet />

export default BannerPage
